import type { RemovableRef, UseStorageOptions } from '@vueuse/core';

import { useSessionStorage as baseUseSessionStorage } from '@vueuse/core';

import { browserStorageNamespacedKey } from '@/utils/browserStorage';

export function useSessionStorage<T = unknown>(key: string): RemovableRef<T | null>;
export function useSessionStorage<T>(
  key: string,
  initialValue: T,
  options?: UseStorageOptions<T>,
): RemovableRef<T>;
export function useSessionStorage<T>(
  key: string,
  initialValue: T | null = null,
  options: UseStorageOptions<T | null> = {},
): RemovableRef<T | null> {
  const dhKey = browserStorageNamespacedKey(key);
  return baseUseSessionStorage(dhKey, initialValue, options);
}
